"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _wordpressHeader = _interopRequireDefault(require("../wordpress-header/wordpress-header"));

var _withStandardPageHeader = _interopRequireDefault(require("../../with-standard-page-header/with-standard-page-header"));

var _default = (0, _withStandardPageHeader.default)(_wordpressHeader.default);

exports.default = _default;